import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadiobuttonsComponent } from './radiobuttons.component';
import { InputContainerModule } from '../input-container/input-container.module';
import { DotIndicatorModule } from '../../dotindicator/dotindicator.module';

@NgModule({
  declarations: [RadiobuttonsComponent],
  imports: [CommonModule, InputContainerModule, DotIndicatorModule],
  exports: [InputContainerModule, RadiobuttonsComponent],
})
export class RadiobuttonsModule {}
